import { motion } from "framer-motion";
import { Gem, Link2, MessageCircle, ShieldCheck, Zap } from "lucide-react";

const ITEMS = [
  {
    icon: Gem,
    title: "Especialização no segmento não residencial",
    desc: "Atuação direcionada ao mercado comercial, corporativo e industrial, com entendimento das particularidades desse tipo de locação.",
  },
  {
    icon: Link2,
    title: "Assertividade na conexão entre imóvel e empresa",
    desc: "Nosso foco não é volume. É compatibilidade. Buscamos gerar encontros mais inteligentes entre espaço e operação.",
  },
  {
    icon: MessageCircle,
    title: "Atendimento próximo e consultivo",
    desc: "Cada imóvel e cada cliente têm uma necessidade diferente. Por isso, conduzimos o processo com atenção, clareza e estratégia.",
  },
  {
    icon: ShieldCheck,
    title: "Mais segurança na negociação",
    desc: "Reduzimos ruídos, organizamos etapas e conduzimos a locação com mais profissionalismo e tranquilidade.",
  },
  {
    icon: Zap,
    title: "Agilidade com critério",
    desc: "Velocidade importa, mas sem perder qualidade na análise e na condução da oportunidade.",
  },
];

export const Differentials = () => {
  return (
    <section
      id="diferenciais"
      className="relative py-24 md:py-32 lg:py-40 overflow-hidden"
      data-testid="differentials-section"
    >
      {/* Soft gold radial glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#D4B366]/5 rounded-full blur-[120px] -z-0" />

      <div className="container mx-auto px-6 md:px-12 lg:px-16 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Sticky header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-5 lg:sticky lg:top-32 lg:self-start"
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="gold-divider" />
              <span className="eyebrow">Diferenciais</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#F5F1EA] mb-6" data-testid="differentials-title">
              Por que escolher a{" "}
              <span className="italic gold-text">Parceria Certa</span>
            </h2>
            <p className="text-[#A2AAC2] text-base leading-[1.8] font-light max-w-md">
              Cinco pilares que transformam a locação comercial em uma experiência estratégica,
              segura e lucrativa.
            </p>
          </motion.div>

          {/* List */}
          <div className="lg:col-span-7 flex flex-col">
            {ITEMS.map((item, i) => {
              const Icon = item.icon;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.7, delay: i * 0.1, ease: [0.2, 0.8, 0.2, 1] }}
                  className="group py-8 border-b border-[#D4B366]/15 last:border-b-0 flex gap-6 md:gap-8 hover:bg-[#0E1E45]/30 px-2 md:px-6 transition-colors duration-500"
                  data-testid={`differential-${i}`}
                >
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 flex items-center justify-center border border-[#D4B366]/40 text-[#E8C97A] group-hover:bg-[#D4B366] group-hover:text-[#0B1A3A] transition-all duration-500">
                      <Icon size={22} strokeWidth={1.3} />
                    </div>
                  </div>
                  <div className="flex-1 pt-1">
                    <div className="flex items-center gap-4 mb-3">
                      <span className="font-display text-[#D4B366]/60 text-sm">
                        0{i + 1}
                      </span>
                      <h3 className="font-display text-xl md:text-2xl text-[#F5F1EA] leading-tight">
                        {item.title}
                      </h3>
                    </div>
                    <p className="text-[#A2AAC2] text-sm md:text-[0.92rem] leading-[1.8] font-light">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
